module.exports = __webpack_public_path__ + "img/banner-35.5d7e9c3e.jpg";